export default "__VITE_ASSET__BPrEQxRb__"